module.exports = __webpack_public_path__ + "img/bg-xmjx.8638b188.png";